// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"a514d1c9","496":"cd7a6766","787":"56b06d95","845":"ef3a1c5f"}[chunkId] + ".chunk.js";
};